import React, { useEffect } from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & {
          'pricing-table-id': string;
          'publishable-key': string;
          'customer-email'?: string;
          'customer-session-client-secret'?: string;
        },
        HTMLElement
      >;
    }
  }
}

interface StripePricingTableProps {
  pricingTableId?: string;
  publishableKey?: string;
}

const StripePricingTable: React.FC<StripePricingTableProps> = ({
  pricingTableId = 'prctbl_1Ron3CPNVfL0iTMEFtI14fwW',
  publishableKey = 'pk_live_51RolpDPNVfL0iTME57dIzbU2jyLDQY1pyaQ30AtgR4UqrNv7prdTRZkbTuQ86zOBL2SwB8YoZjgVrODTGTpNYnRj00RDpTmnqQ'
}) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up the script when component unmounts
      const scripts = document.querySelectorAll('script[src="https://js.stripe.com/v3/pricing-table.js"]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  return (
    <div className="stripe-pricing-table-wrapper rounded-lg overflow-hidden">
      <stripe-pricing-table 
        pricing-table-id={pricingTableId}
        publishable-key={publishableKey}>
      </stripe-pricing-table>
    </div>
  );
};

export default StripePricingTable;